import { useEffect, useState } from "react";
import CreateBlog from "../components/CreateBlog";
import BlogList from "../components/BlogList";
import Header from "../components/Header";
import CreateResources from "../components/CreateResources";

function Dashboard() {
  const [activeComponent, setActiveComponent] = useState("create_blog");
  const [editingPost, setEditingPost] = useState(null); // 💡 new state

  const handleEditPost = (post) => {
    setEditingPost(post);
    setActiveComponent("create_blog");
  };

  const renderComponent = () => {
    switch (activeComponent) {
      case "create_blog":
        return (
          <CreateBlog
            editingPost={editingPost}
            onDone={() => {
              setEditingPost(null);
              setActiveComponent("list");
            }}
          />
        );
      case "list":
        return <BlogList onEdit={handleEditPost} />;
      case  "createresources":
        return <CreateResources />;
    }
  };

  return (
    <div className="dashboard">
      <Header />
      <div className="dashborad_wrapper">
        <aside className="sidebar">
          <ul>
            <li onClick={() => {
              setEditingPost(null); // reset editing
              setActiveComponent("create_blog");
            }}>
              Create Blog
            </li>

            <li onClick={() => setActiveComponent("list")}>Resource Library</li>
            <li onClick={() => setActiveComponent("createresources")}>Resource</li>
          </ul>
        </aside>
        <main className="main-content">{renderComponent()}</main>
      </div>
    </div>
  );
}


export default Dashboard;
